import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const getUserBooks = async (payload) => {
  // payload should contain: { userId, title }
  const response = await apiService.post(apiRoutes.userBooksList, payload);
  return response.data;
};

export const getBooksDetail = async (payload) => {
  // payload should contain: { userId, title }
  const response = await apiService.post(apiRoutes.booksDetail, payload);
  return response.data;
};

export const getChapterDetail = async (payload) => {
  // payload should contain: { userId, title }
  const response = await apiService.post(apiRoutes.chapterDetail, payload);
  return response.data;
};

export const getBooksList = async (payload) => {
  // payload should contain: { userId, title }
  const response = await apiService.post(apiRoutes.booksList, payload);
  return response.data;
};


